import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import AreasList from '../components/AreasList'

export default function ManageAreas() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">Areas</h1>
        <Link to="/new-area"><button className="memberAddButton">Add New</button></Link>
      </div>
        <AreasList />
    </div>
  )
}
